import React from "react";

interface Props {
    value: number;
    onFocus?: () => void;
    onChange: (value: number) => void;
    fullWidth?: boolean;
}

export function AmountInput(props: Props) {
    const {fullWidth} = props;
    const [strValue, setStrValue] = React.useState(props.value.toString());

    React.useEffect(() => {
        setStrValue(props.value.toString());
    }, [props.value]);

    function handleInputDone() {
        const numericStrValues = strValue.replace(/[^0-9]/g, '');
        if (numericStrValues) {
            const numberValue = Number(numericStrValues);
            props.onChange(numberValue);
            setStrValue(numberValue.toString());
        } else {
            setStrValue(props.value.toString());
        }
    }

    return <input
        value={strValue}
        style={{width: fullWidth ? '100%' : 100, height: 32, boxSizing: "border-box"}}
        onChange={e => setStrValue(e.target.value)}
        onFocus={props.onFocus}
        onBlur={handleInputDone}
        onKeyDown={e => {
            if (e.key === 'Enter') {
                handleInputDone();
            }
        }}
    />
}